import Skinnyjeans from "../../images/circleIcons/2x/1-Skinnyjeans.png";
import Straws from "../../images/circleIcons/2x/2-Straws.png";
import Spaghetti from "../../images/circleIcons/2x/3-Spaghetti.png";
import Iceland from "../../images/circleIcons/2x/4-Iceland.png";
import Skateboard from "../../images/circleIcons/2x/5-Skateboard.png";
import AlmondMilk from "../../images/circleIcons/2x/6-Almond milk.png";
import bfastSandwich from "../../images/circleIcons/2x/7-bfast sandwich.png";
import Trashcan from "../../images/circleIcons/2x/8-Trashcan.png";
import CoffeeBeans from "../../images/circleIcons/2x/9-Coffee beans.png";
import Astronaut from "../../images/circleIcons/2x/10-Astronaut.png";

const questionAnswers = [
  {
    title: "MARKET FOR SKINNY JEANS",
    question:
      "TikTok influencers rave about wide leg jeans.",
    subQuestion: "Consider the market for skinny jeans (a now out-of-fashion style). What happens?",
    icon: Skinnyjeans,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "If wide leg jeans become more popular, this means that fewer people will want to wear skinny jeans. Demand for skinny jeans will decrease. Therefore, the demand curve for skinny jeans will shift to the left.",
  },
  {
    title: "MARKET FOR PLASTIC STRAWS",
    question: "Local governments impose a tax on plastic straw producers.",
    subQuestion: "Consider the market for plastic straws. What happens?",
    icon: Straws,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "If the government introduces a tax on straw producers, this will discourage them from producing straws. Therefore, the supply curve for straws will shift to the left.",
  },

  {
    title: "MARKET FOR SPAGHETTI NOODLES",
    question: "Record harvests of tomatoes result in lower prices for spaghetti sauce.",
    subQuestion: "Consider the market for spaghetti noodles. What happens?",
    icon: Spaghetti,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "Spaghetti sauce and spaghetti noodles are complements. When the price of spaghetti sauce declines, more people will want to make spaghetti, increasing the demand for spaghetti noodles. The demand curve for spaghetti noodles will shift to the right.",
  },

  {
    title: "MARKET FOR BREAKFAST SANDWICHES",
    question: "As more workers return to the office, they resume purchasing breakfast on their way to the office.",
    subQuestion: "Consider the market for breakfast sandwiches. What happens?",
    icon: bfastSandwich,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "More people are interested in buying breafast. Therefore, the demand curve for breakfast sandwiches will shift to the right.",
  },

  {
    title: "MARKET FOR COFFEE BEANS",
    question: "A severe drought in Brazil drastically reduces coffee harvests.",
    subQuestion: "Consider the market for coffee beans. What happens?",
    icon: CoffeeBeans,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "The drought decreases the supply of coffee beans. Therefore, the supply curve for coffee beans will shift to the left.",
  },

  {
    title: "MARKET FOR ICELAND HOTEL ROOMS",
    question: "Thanks to new technology, astronomers predict that northern lights will appear more frequently this winter.",
    subQuestion: "Consider the market for hotel rooms in Iceland, a common location for viewing the northern lights. What happens?",
    icon: Iceland,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "More travelers will choose hotels located in places where the northern lights are visible. Therefore, the demand for hotel rooms in viewing locations, including Iceland, will increase. The demand curve for hotel rooms in Iceland will shift to the right.",
  },

  {
    title: "MARKET FOR SKATEBOARDS",
    question:
      "Three major skateboard manufacturers announce that they will be closing their factories, effective immediately.",
    subQuestion: "Consider the market for skateboards. What happens?",
    icon: Skateboard,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "With major manufacturers leaving the market, the supply of skateboards will decrease. Therefore, the supply curve for skateboards will shift to the left.",
  },

  {
    title: "MARKET FOR ALMOND MILK",
    question:
      "The price of oat milk goes down.",
    subQuestion: "Consider the market for almond milk. What happens?",
    icon: AlmondMilk,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "Oat milk and almond milk are substitutes. If the price of oat milk declines, more people will prefer oat milk to almond milk. Therefore, the demand curve for almond milk will shift to the left.",
  },

  {
    title: "MARKET FOR TRASH CANS",
    question:
      "Airlines reduce the size allowance for carry-on bags.",
    subQuestion: "Consider the market for trash cans. What happens?",
    icon: Trashcan,
    answer: "Nothing happens",
    graphType: "supply curve",
    briefness:
      "The size of carry-on bags is unlikely to affect the trash can market. There will be no shift in the trash can market.",
  },

  {
    title: "MARKET FOR SPACE TRAVEL",
    question: "New technology enables safe, cost-effective shipment of liquid hydrogen—the preferred fuel for space rockets.",
    subQuestion: "Consider the market for space travel. What happens?",
    icon: Astronaut,
    answer: "Supply curve shifts right",
    graphType: "supply curve",
    briefness:
      "Lower fuel costs will reduce the cost of space travel, enabling supply to increase. Therefore, the supply curve for space travel will shift to the right.",
  },
];

export default questionAnswers;
